<template>
    <div :class="['table-of-contents', {'not-logged': disabled}]">
        <div class="table-of-contents__header">
            <span :class="'icon-' + headerIcon"></span>
            <span v-html="header"></span>
        </div>
        <TotemScrollbar class="table-of-contents__scrollbar" :shouldScrollOnInit="shouldScrollOnInit">
            <slot />
        </TotemScrollbar>
    </div>
</template>

<script>

    export default {
        name: 'table-of-contents',
        props: {
            header: String,
            headerIcon: String,
            disabled: {
                type: Boolean,
                default: false
            },
            shouldScrollOnInit: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    .table-of-contents {
        background-color: $eerie_black;
        width: 300px;

        [class*="desktop_xxxl"] & {
          width: 370px;
        }
        [class*="mobile"] & {
          width: 100%;
        }

        &.not-logged {
            color: $silver_chalice;
        }

        &__header {
            font-size: 1.7rem;
            font-family: Quicksand-Bold, sans-serif;
            display: flex;
            align-items: center;
            padding: 15px 20px 15px 15px;
            position: relative;
            cursor: pointer;
            background-color: $orange;
            color: $white;
        }

        &__scrollbar {
            max-height: 700px;
        }

        [class*="icon-"] {
            font-size: 3rem;
            margin: 0 18px 0 0;
        }

        .icon-info {
            margin-left: auto;
        }
    }
</style>
